var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { FlightButton, FlightTextInput, FlightLabelSearch } from '@flybits/design-system';
// TS throws errors from lodash type definitions if installed
// tsconfig exclude doesn't seem to work
// Temporary hack after failing consistently for so long :(
// @ts-ignore
import { debounce, isEqual } from 'lodash';
import '../../assets/styles/ManageLocation.scss';
var mapBaseZoom = 15;
var tristanDaCunha = { lat: -37.111112, lng: -12.28834 };
var locationDetectionErrorMsg = 'Failed to detect location using Google Maps. Please check if your browser has location permission and reload the page.';
var ManageLocationComponent = function (_a) {
    var locationPayload = _a.locationPayload, _b = _a.contextLabels, contextLabels = _b === void 0 ? [] : _b, _c = _a.locationLabels, locationLabels = _c === void 0 ? [] : _c, locations = _a.locations, isEditMode = _a.isEditMode, selectedLocation = _a.selectedLocation, isLabelRequired = _a.isLabelRequired, setLocationPayload = _a.setLocationPayload, isUniqueLocationNameError = _a.isUniqueLocationNameError, setUniqueLocationNameError = _a.setUniqueLocationNameError, setShowLocationSnackbar = _a.setShowLocationSnackbar, setLocationSnackbarMessage = _a.setLocationSnackbarMessage;
    var mapRef = useRef(null);
    var inputRef = useRef(null);
    var _d = __read(useState(''), 2), locationSearchValue = _d[0], setLocationSearchValue = _d[1];
    var _e = __read(useState(isEditMode ? selectedLocation === null || selectedLocation === void 0 ? void 0 : selectedLocation.name : ''), 2), locationName = _e[0], setLocationName = _e[1];
    var _f = __read(useState(isEditMode ? selectedLocation === null || selectedLocation === void 0 ? void 0 : selectedLocation.address : ''), 2), locationAddress = _f[0], setLocationAddress = _f[1];
    var _g = __read(useState(), 2), polygon = _g[0], setPolygon = _g[1];
    var _h = __read(useState(), 2), map = _h[0], setMap = _h[1];
    var _j = __read(useState(), 2), currentLocation = _j[0], setCurrentLocation = _j[1];
    var _k = __read(useState(false), 2), isDetectingLocation = _k[0], setIsDetectingLocation = _k[1];
    var createShapeControl = useRef(null);
    var centreMapControl = useRef(null);
    var _l = __read(useState([]), 2), labelsSearchOptions = _l[0], setLabelsSearchOptions = _l[1];
    var _m = __read(useState([]), 2), selectedLabels = _m[0], setSelectedLabels = _m[1];
    var _o = __read(useState(isEditMode ? selectedLocation === null || selectedLocation === void 0 ? void 0 : selectedLocation.labels : []), 2), addedLabels = _o[0], setAddedLabels = _o[1];
    var _p = __read(useState(false), 2), isLabelsDropdownOpen = _p[0], setIsLabelsDropdownOpen = _p[1];
    var labelSearchRef = useRef(null);
    // ToDo - Check if this fn would be required in the future
    // const getPolygonBounds = (polygon: google.maps.Polygon) => {
    //   const bounds = new window.google.maps.LatLngBounds();
    //   polygon.getPath()?.forEach(coordinates => bounds.extend(coordinates));
    //   console.log(bounds);
    //   return bounds;
    // };
    var getShapeCenter = function (shape) {
        var center = {
            lat: 0,
            lng: 0,
        };
        var lat1, lng1, lat2, lng2;
        for (var count = 0; count < shape.length; count++) {
            if (count === 0) {
                lat1 = lat2 = shape[count].lat;
                lng1 = lng2 = shape[count].lng;
            }
            else {
                if (lat1 < shape[count].lat) {
                    lat1 = shape[count].lat;
                }
                if (lat2 > shape[count].lat) {
                    lat2 = shape[count].lat;
                }
                if (lng1 < shape[count].lng) {
                    lng1 = shape[count].lng;
                }
                if (lng2 > shape[count].lng) {
                    lng2 = shape[count].lng;
                }
            }
        }
        center.lat = lat2 + (lat1 - lat2) / 2;
        center.lng = lng2 + (lng1 - lng2) / 2;
        return center;
    };
    var initMap = useCallback(function () {
        // Initialize map
        var map = new google.maps.Map(mapRef.current, {
            center: isEditMode ? getShapeCenter(selectedLocation === null || selectedLocation === void 0 ? void 0 : selectedLocation.shape[0]) : tristanDaCunha,
            zoom: mapBaseZoom - 4,
            mapTypeId: 'roadmap',
            gestureHandling: 'greedy',
            mapTypeControl: false,
            fullscreenControl: false,
            streetViewControl: false,
            zoomControl: true /* To be replaced with custom zoom controls */,
            zoomControlOptions: {
                position: google.maps.ControlPosition.TOP_RIGHT,
            },
        });
        if (isEditMode) {
            var newPolygon_1 = new window.google.maps.Polygon({
                paths: selectedLocation === null || selectedLocation === void 0 ? void 0 : selectedLocation.shape[0],
                strokeColor: '#FF0000',
                strokeOpacity: 0.8,
                strokeWeight: 2,
                fillColor: '#FF0000',
                fillOpacity: 0.35,
                editable: true,
                draggable: true,
                suppressUndo: true,
            });
            setPolygon(newPolygon_1);
            newPolygon_1.setMap(map);
            setPolygonShape(newPolygon_1);
            var bounds = new google.maps.LatLngBounds();
            for (var i = 0; i < (selectedLocation === null || selectedLocation === void 0 ? void 0 : selectedLocation.shape[0].length); i++) {
                bounds.extend(selectedLocation === null || selectedLocation === void 0 ? void 0 : selectedLocation.shape[0][i]);
            }
            map.fitBounds(bounds);
            map.setZoom(mapBaseZoom);
            newPolygon_1.addListener('mouseup', function () {
                setPolygonShape(newPolygon_1);
            });
            newPolygon_1.addListener('dragend', function () {
                setPolygonShape(newPolygon_1);
                updateAddress(map);
            });
            setLocationPayload({
                name: selectedLocation === null || selectedLocation === void 0 ? void 0 : selectedLocation.name,
                address: selectedLocation === null || selectedLocation === void 0 ? void 0 : selectedLocation.address,
                shape: selectedLocation === null || selectedLocation === void 0 ? void 0 : selectedLocation.shape,
                labels: selectedLocation === null || selectedLocation === void 0 ? void 0 : selectedLocation.labels,
            });
        }
        // Add custom map controls
        createShapeControl.current && map.controls[google.maps.ControlPosition.LEFT_TOP].push(createShapeControl.current);
        centreMapControl.current && map.controls[google.maps.ControlPosition.RIGHT_BOTTOM].push(centreMapControl.current);
        setMap(map);
    }, []);
    var detectCurrentLocation = useCallback(function () {
        if (window.navigator && window.navigator.geolocation) {
            setIsDetectingLocation(true);
            navigator.geolocation.getCurrentPosition(function (geoposition) {
                setCurrentLocation({
                    lat: geoposition.coords.latitude,
                    lng: geoposition.coords.longitude,
                });
                setIsDetectingLocation(false);
            }, function () {
                setCurrentLocation(tristanDaCunha);
                setIsDetectingLocation(false);
                setShowLocationSnackbar(true);
                setLocationSnackbarMessage(locationDetectionErrorMsg);
            });
        }
        else {
            setIsDetectingLocation(false);
            setCurrentLocation(tristanDaCunha);
            setShowLocationSnackbar(true);
            setLocationSnackbarMessage(locationDetectionErrorMsg);
        }
    }, [setShowLocationSnackbar, setLocationSnackbarMessage]);
    useEffect(function () {
        setLocationPayload(function (locationPayload) { return (__assign(__assign({}, locationPayload), { address: locationAddress })); });
    }, [locationAddress]);
    useEffect(function () {
        initMap();
    }, [initMap]);
    useEffect(function () {
        if (map) {
            if (!isEditMode) {
                detectCurrentLocation();
            }
        }
    }, [map, detectCurrentLocation]);
    useEffect(function () {
        if (map && currentLocation) {
            map.setCenter(currentLocation);
            map.setZoom(isEqual(currentLocation, tristanDaCunha) ? mapBaseZoom - 4 : mapBaseZoom);
        }
    }, [map, currentLocation]);
    useEffect(function () {
        if (inputRef.current && map) {
            var autocomplete_1 = new google.maps.places.Autocomplete(inputRef.current, {
                fields: ['formatted_address', 'geometry', 'name'],
                strictBounds: false,
            });
            autocomplete_1.bindTo('bounds', map);
            autocomplete_1.addListener('place_changed', function () {
                var place = autocomplete_1.getPlace();
                var address = place.formatted_address || '';
                setLocationAddress(address);
                setLocationPayload(function (locationPayload) { return (__assign(__assign({}, locationPayload), { address: address })); });
                if (place.geometry && place.geometry.location) {
                    if (place.geometry.viewport) {
                        map.fitBounds(place.geometry.viewport);
                    }
                    else {
                        map.setCenter(place.geometry.location);
                        map.setZoom(mapBaseZoom);
                    }
                }
            });
        }
    }, [inputRef, map, setLocationPayload]);
    var setPolygonShape = function (newPolygon) {
        var _a, _b, _c, _d;
        var shape = [[]];
        var arrCoordinates = newPolygon
            .getPath()
            .getArray()
            .map(function (coordinate) {
            return coordinate.toJSON();
        });
        // Assumption - The coordinates array is stored in the first index of shape array
        shape[0] = [];
        for (var count = 0; count < arrCoordinates.length; count++) {
            shape[0].push(arrCoordinates[count]);
        }
        if (((_a = shape[0][0]) === null || _a === void 0 ? void 0 : _a.lat) !== ((_b = shape[0][shape[0].length - 1]) === null || _b === void 0 ? void 0 : _b.lat) &&
            ((_c = shape[0][0]) === null || _c === void 0 ? void 0 : _c.lng) !== ((_d = shape[0][shape[0].length - 1]) === null || _d === void 0 ? void 0 : _d.lng)) {
            // Push the first coordinate again to enclose the shape area
            shape[0].push(shape[0][0]);
        }
        setLocationPayload(function (locationPayload) { return (__assign(__assign({}, locationPayload), { shape: shape })); });
    };
    var updateAddress = function (map) {
        new window.google.maps.Geocoder().geocode({
            location: map.getCenter(),
        }, function (results, status) {
            if (status.toUpperCase() === 'OK') {
                var place = results === null || results === void 0 ? void 0 : results[0];
                if (place === null || place === void 0 ? void 0 : place.formatted_address) {
                    var address = place.formatted_address;
                    setLocationAddress(address);
                }
            }
        });
    };
    var handleLabelsChange = useCallback(function (labelName) {
        if (!labelName) {
            // Reset to all available options
            setLabelsSearchOptions(__spreadArray([], __read(new Set(__spreadArray(__spreadArray([], __read(contextLabels), false), __read(locationLabels), false))), false));
        }
        else {
            setLabelsSearchOptions(function (options) { return options.filter(function (label) { return label.startsWith(labelName); }); });
            setIsLabelsDropdownOpen(true);
        }
    }, [contextLabels, locationLabels]);
    var handleLabelAdd = function (labels) {
        setSelectedLabels([]);
        setAddedLabels(labels);
        setLocationPayload(function (locationPayload) { return (__assign(__assign({}, locationPayload), { labels: __spreadArray([], __read(labels), false) })); });
    };
    var handleLabelRemove = function (removedLabel) {
        var remainingLabels = addedLabels.filter(function (selectedLabel) { return selectedLabel !== removedLabel; });
        setAddedLabels(remainingLabels);
        setLocationPayload(function (locationPayload) { return (__assign(__assign({}, locationPayload), { labels: remainingLabels })); });
    };
    var handleLabelsTriggerClick = useCallback(function () {
        // Set all available options
        setLabelsSearchOptions(__spreadArray([], __read(new Set(__spreadArray(__spreadArray([], __read(contextLabels), false), __read(locationLabels), false))), false));
        setIsLabelsDropdownOpen(true);
        setTimeout(function () {
            var _a;
            (_a = labelSearchRef.current) === null || _a === void 0 ? void 0 : _a.scrollIntoView({ behavior: 'smooth' });
        }, 50);
    }, [contextLabels, locationLabels]);
    var debouncedHandleChangeLocationName = useMemo(function () {
        return debounce(function (locationName) {
            var e_1, _a;
            setLocationPayload(function (locationPayload) { return (__assign(__assign({}, locationPayload), { name: locationName })); });
            try {
                for (var locations_1 = __values(locations), locations_1_1 = locations_1.next(); !locations_1_1.done; locations_1_1 = locations_1.next()) {
                    var location_1 = locations_1_1.value;
                    if (locationName.toLowerCase() === location_1.name.toLowerCase()) {
                        setUniqueLocationNameError(true);
                        return;
                    }
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (locations_1_1 && !locations_1_1.done && (_a = locations_1.return)) _a.call(locations_1);
                }
                finally { if (e_1) throw e_1.error; }
            }
            setUniqueLocationNameError(false);
        }, 500);
    }, [locations, setLocationPayload, setUniqueLocationNameError]);
    return (React.createElement("div", { className: "manage-location" },
        React.createElement("div", { className: "manage-location__autocomplete" },
            React.createElement(FlightTextInput, { inputRef: inputRef, className: "manage-location__input", type: "text", placeholderText: "Search for an address", width: "100%", iconInput: "search", hasClearIcon: true, value: locationSearchValue, onChange: function (e) {
                    var searchValue = e.target.value || '';
                    setLocationSearchValue(searchValue);
                }, onBlur: function (e) {
                    var searchValue = e.target.value || '';
                    setLocationSearchValue(searchValue);
                } })),
        React.createElement("div", { className: "manage-location" },
            React.createElement("div", { className: "manage-location__map", ref: mapRef },
                React.createElement("div", { className: "manage-location__map__map-control", ref: createShapeControl },
                    React.createElement(FlightButton, { className: "manage-location__map__map-control__btn manage-location__map__map-control__btn--not-loading".concat(polygon ? ' manage-location__map__map-control__btn--reset-shape' : ''), ariaLabel: "Create Shape", label: polygon ? 'Reset Shape' : 'Create Shape', iconLeft: polygon ? 'mapControlMinus' : 'mapCreateShape', onClick: function () {
                            var _a, _b, _c;
                            if (polygon) {
                                polygon.setMap(null);
                                setPolygon(null);
                                setLocationAddress('');
                                setLocationPayload(function (locationPayload) { return (__assign(__assign({}, locationPayload), { shape: [[]], address: '' })); });
                            }
                            else {
                                if (map) {
                                    var computeOffset = (_c = (_b = (_a = google.maps) === null || _a === void 0 ? void 0 : _a.geometry) === null || _b === void 0 ? void 0 : _b.spherical) === null || _c === void 0 ? void 0 : _c.computeOffset;
                                    var distance = 150;
                                    var paths = [];
                                    var centerMap = map.getCenter();
                                    if (typeof centerMap !== 'undefined') {
                                        paths.push(computeOffset(centerMap, distance, -45));
                                        paths.push(computeOffset(centerMap, distance, 45));
                                        paths.push(computeOffset(centerMap, distance, 135));
                                        paths.push(computeOffset(centerMap, distance, -135));
                                    }
                                    var newPolygon_2 = new window.google.maps.Polygon({
                                        paths: paths,
                                        strokeColor: '#FF0000',
                                        strokeOpacity: 0.8,
                                        strokeWeight: 2,
                                        fillColor: '#FF0000',
                                        fillOpacity: 0.35,
                                        editable: true,
                                        draggable: true,
                                        /**
                                         * deprecated PolygonOption
                                         * to hide the undo button on the polygon area
                                         * until we create a handler for undo
                                         */
                                        suppressUndo: true,
                                    });
                                    setPolygon(newPolygon_2);
                                    newPolygon_2.setMap(map);
                                    updateAddress(map);
                                    setPolygonShape(newPolygon_2);
                                    map.setZoom(mapBaseZoom);
                                    newPolygon_2.addListener('mouseup', function () {
                                        setPolygonShape(newPolygon_2);
                                    });
                                    newPolygon_2.addListener('dragend', function () {
                                        setPolygonShape(newPolygon_2);
                                        updateAddress(map);
                                    });
                                }
                            }
                        }, theme: "minor" })),
                React.createElement("div", { className: "manage-location__map__map-control", ref: centreMapControl },
                    React.createElement(FlightButton, { className: "\n                manage-location__map__map-control__btn".concat(!isDetectingLocation ? ' manage-location__map__map-control__btn--not-loading' : '', "\n              "), ariaLabel: "Go to current location", onClick: function () {
                            detectCurrentLocation();
                        }, loading: isDetectingLocation, theme: "minor", iconLeft: "mapCrosshairs" }))),
            React.createElement("div", { className: "manage-location__inputs-container" },
                React.createElement(FlightTextInput, { className: "manage-location__input", errorMessage: isUniqueLocationNameError ? (React.createElement(React.Fragment, null,
                        "A location with the name ",
                        React.createElement("b", null, locationName),
                        " already exists")) : ("Please enter a name"), label: "Name", type: "text", width: "100%", hasError: isUniqueLocationNameError || !locationName, value: locationName, onChange: function (e) {
                        var name = e.target.value || '';
                        setLocationName(name);
                        debouncedHandleChangeLocationName(name);
                    } }),
                React.createElement(FlightTextInput, { className: "manage-location__input", label: "Address", type: "text", width: "100%", value: locationAddress, onChange: function (e) {
                        var address = e.target.value || '';
                        setLocationAddress(address);
                    } })),
            React.createElement("div", { className: "manage-location__labels-container" },
                React.createElement("div", { className: "manage-location__labels-container__title" }, "You can add one or many labels"),
                React.createElement("div", { ref: labelSearchRef, className: isLabelsDropdownOpen ? 'open' : '' },
                    React.createElement(FlightLabelSearch, { height: "200px", width: "360px", labels: addedLabels, options: labelsSearchOptions, hasError: isLabelRequired && !(addedLabels === null || addedLabels === void 0 ? void 0 : addedLabels.length), errorMessage: "Requires at least one label", onLabelAdd: handleLabelAdd, onLabelChange: handleLabelsChange, onLabelClick: handleLabelRemove, onLabelRemove: handleLabelRemove, onLabelSelected: setSelectedLabels, onTriggerClick: handleLabelsTriggerClick, onOutsideClick: function () { return setIsLabelsDropdownOpen(false); } }))))));
};
export var ManageLocation = React.memo(ManageLocationComponent);
//# sourceMappingURL=ManageLocation.js.map